/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AdministrativeFieldsHistoryResponse } from '../models/administrative-fields-history-response';
import { CompanyDetailResponse } from '../models/company-detail-response';
import { deleteApiAdministrativeV1Id } from '../fn/administrative/delete-api-administrative-v-1-id';
import { DeleteApiAdministrativeV1Id$Params } from '../fn/administrative/delete-api-administrative-v-1-id';
import { GetAdministrativesResponse } from '../models/get-administratives-response';
import { GetAdministrativeStructuresResponse } from '../models/get-administrative-structures-response';
import { getApiAdministrativeV1Id$Json } from '../fn/administrative/get-api-administrative-v-1-id-json';
import { GetApiAdministrativeV1Id$Json$Params } from '../fn/administrative/get-api-administrative-v-1-id-json';
import { getApiAdministrativeV1Id$Plain } from '../fn/administrative/get-api-administrative-v-1-id-plain';
import { GetApiAdministrativeV1Id$Plain$Params } from '../fn/administrative/get-api-administrative-v-1-id-plain';
import { getApiAdministrativeV1IdAgents$Json } from '../fn/administrative/get-api-administrative-v-1-id-agents-json';
import { GetApiAdministrativeV1IdAgents$Json$Params } from '../fn/administrative/get-api-administrative-v-1-id-agents-json';
import { getApiAdministrativeV1IdAgents$Plain } from '../fn/administrative/get-api-administrative-v-1-id-agents-plain';
import { GetApiAdministrativeV1IdAgents$Plain$Params } from '../fn/administrative/get-api-administrative-v-1-id-agents-plain';
import { getApiAdministrativeV1IdCustomers$Json } from '../fn/administrative/get-api-administrative-v-1-id-customers-json';
import { GetApiAdministrativeV1IdCustomers$Json$Params } from '../fn/administrative/get-api-administrative-v-1-id-customers-json';
import { getApiAdministrativeV1IdCustomers$Plain } from '../fn/administrative/get-api-administrative-v-1-id-customers-plain';
import { GetApiAdministrativeV1IdCustomers$Plain$Params } from '../fn/administrative/get-api-administrative-v-1-id-customers-plain';
import { getApiAdministrativeV1IdStructures$Json } from '../fn/administrative/get-api-administrative-v-1-id-structures-json';
import { GetApiAdministrativeV1IdStructures$Json$Params } from '../fn/administrative/get-api-administrative-v-1-id-structures-json';
import { getApiAdministrativeV1IdStructures$Plain } from '../fn/administrative/get-api-administrative-v-1-id-structures-plain';
import { GetApiAdministrativeV1IdStructures$Plain$Params } from '../fn/administrative/get-api-administrative-v-1-id-structures-plain';
import { GetCompanyAgentsResponse } from '../models/get-company-agents-response';
import { GetCompanyCustomersResponse } from '../models/get-company-customers-response';
import { postAdministrativeV1CompaniesUserDetail$Json } from '../fn/administrative/post-administrative-v-1-companies-user-detail-json';
import { PostAdministrativeV1CompaniesUserDetail$Json$Params } from '../fn/administrative/post-administrative-v-1-companies-user-detail-json';
import { postAdministrativeV1CompaniesUserDetail$Plain } from '../fn/administrative/post-administrative-v-1-companies-user-detail-plain';
import { PostAdministrativeV1CompaniesUserDetail$Plain$Params } from '../fn/administrative/post-administrative-v-1-companies-user-detail-plain';
import { postAdministrativeV1CompaniesWithoutBreakVisibility$Json } from '../fn/administrative/post-administrative-v-1-companies-without-break-visibility-json';
import { PostAdministrativeV1CompaniesWithoutBreakVisibility$Json$Params } from '../fn/administrative/post-administrative-v-1-companies-without-break-visibility-json';
import { postAdministrativeV1CompaniesWithoutBreakVisibility$Plain } from '../fn/administrative/post-administrative-v-1-companies-without-break-visibility-plain';
import { PostAdministrativeV1CompaniesWithoutBreakVisibility$Plain$Params } from '../fn/administrative/post-administrative-v-1-companies-without-break-visibility-plain';
import { postApiAdministrativeV1$Json } from '../fn/administrative/post-api-administrative-v-1-json';
import { PostApiAdministrativeV1$Json$Params } from '../fn/administrative/post-api-administrative-v-1-json';
import { postApiAdministrativeV1$Plain } from '../fn/administrative/post-api-administrative-v-1-plain';
import { PostApiAdministrativeV1$Plain$Params } from '../fn/administrative/post-api-administrative-v-1-plain';
import { postApiAdministrativeV1Create$Json } from '../fn/administrative/post-api-administrative-v-1-create-json';
import { PostApiAdministrativeV1Create$Json$Params } from '../fn/administrative/post-api-administrative-v-1-create-json';
import { postApiAdministrativeV1Create$Plain } from '../fn/administrative/post-api-administrative-v-1-create-plain';
import { PostApiAdministrativeV1Create$Plain$Params } from '../fn/administrative/post-api-administrative-v-1-create-plain';
import { postApiAdministrativeV1Export$Json } from '../fn/administrative/post-api-administrative-v-1-export-json';
import { PostApiAdministrativeV1Export$Json$Params } from '../fn/administrative/post-api-administrative-v-1-export-json';
import { postApiAdministrativeV1Export$Plain } from '../fn/administrative/post-api-administrative-v-1-export-plain';
import { PostApiAdministrativeV1Export$Plain$Params } from '../fn/administrative/post-api-administrative-v-1-export-plain';
import { postApiAdministrativeV1IdHistory$Json } from '../fn/administrative/post-api-administrative-v-1-id-history-json';
import { PostApiAdministrativeV1IdHistory$Json$Params } from '../fn/administrative/post-api-administrative-v-1-id-history-json';
import { postApiAdministrativeV1IdHistory$Plain } from '../fn/administrative/post-api-administrative-v-1-id-history-plain';
import { PostApiAdministrativeV1IdHistory$Plain$Params } from '../fn/administrative/post-api-administrative-v-1-id-history-plain';
import { postApiAdministrativeV1IdHistoryExport$Json } from '../fn/administrative/post-api-administrative-v-1-id-history-export-json';
import { PostApiAdministrativeV1IdHistoryExport$Json$Params } from '../fn/administrative/post-api-administrative-v-1-id-history-export-json';
import { postApiAdministrativeV1IdHistoryExport$Plain } from '../fn/administrative/post-api-administrative-v-1-id-history-export-plain';
import { PostApiAdministrativeV1IdHistoryExport$Plain$Params } from '../fn/administrative/post-api-administrative-v-1-id-history-export-plain';
import { postApiAdministrativeV1IdLock } from '../fn/administrative/post-api-administrative-v-1-id-lock';
import { PostApiAdministrativeV1IdLock$Params } from '../fn/administrative/post-api-administrative-v-1-id-lock';
import { postApiAdministrativeV1IdUnlock } from '../fn/administrative/post-api-administrative-v-1-id-unlock';
import { PostApiAdministrativeV1IdUnlock$Params } from '../fn/administrative/post-api-administrative-v-1-id-unlock';
import { putApiAdministrativeV1Id$Json } from '../fn/administrative/put-api-administrative-v-1-id-json';
import { PutApiAdministrativeV1Id$Json$Params } from '../fn/administrative/put-api-administrative-v-1-id-json';
import { putApiAdministrativeV1Id$Plain } from '../fn/administrative/put-api-administrative-v-1-id-plain';
import { PutApiAdministrativeV1Id$Plain$Params } from '../fn/administrative/put-api-administrative-v-1-id-plain';

@Injectable({ providedIn: 'root' })
export class AdministrativeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postApiAdministrativeV1()` */
  static readonly PostApiAdministrativeV1Path = '/private/v1/companies';

  /**
   * Retrive the list all the existing Companies from the database asynchronously.
   *
   * Retrive the list all the existing Companies from the database asynchronously
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAdministrativeV1$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAdministrativeV1$Plain$Response(params?: PostApiAdministrativeV1$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAdministrativesResponse>> {
    return postApiAdministrativeV1$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrive the list all the existing Companies from the database asynchronously.
   *
   * Retrive the list all the existing Companies from the database asynchronously
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAdministrativeV1$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAdministrativeV1$Plain(params?: PostApiAdministrativeV1$Plain$Params, context?: HttpContext): Observable<GetAdministrativesResponse> {
    return this.postApiAdministrativeV1$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetAdministrativesResponse>): GetAdministrativesResponse => r.body)
    );
  }

  /**
   * Retrive the list all the existing Companies from the database asynchronously.
   *
   * Retrive the list all the existing Companies from the database asynchronously
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAdministrativeV1$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAdministrativeV1$Json$Response(params?: PostApiAdministrativeV1$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAdministrativesResponse>> {
    return postApiAdministrativeV1$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrive the list all the existing Companies from the database asynchronously.
   *
   * Retrive the list all the existing Companies from the database asynchronously
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAdministrativeV1$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAdministrativeV1$Json(params?: PostApiAdministrativeV1$Json$Params, context?: HttpContext): Observable<GetAdministrativesResponse> {
    return this.postApiAdministrativeV1$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetAdministrativesResponse>): GetAdministrativesResponse => r.body)
    );
  }

  /** Path part for operation `getApiAdministrativeV1Id()` */
  static readonly GetApiAdministrativeV1IdPath = '/private/v1/companies/{id}';

  /**
   * Retrieves a company by its ID from the database asynchronously.
   *
   * Retrieves a company by its ID from the database asynchronously.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiAdministrativeV1Id$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiAdministrativeV1Id$Plain$Response(params: GetApiAdministrativeV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyDetailResponse>> {
    return getApiAdministrativeV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a company by its ID from the database asynchronously.
   *
   * Retrieves a company by its ID from the database asynchronously.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiAdministrativeV1Id$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiAdministrativeV1Id$Plain(params: GetApiAdministrativeV1Id$Plain$Params, context?: HttpContext): Observable<CompanyDetailResponse> {
    return this.getApiAdministrativeV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompanyDetailResponse>): CompanyDetailResponse => r.body)
    );
  }

  /**
   * Retrieves a company by its ID from the database asynchronously.
   *
   * Retrieves a company by its ID from the database asynchronously.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiAdministrativeV1Id$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiAdministrativeV1Id$Json$Response(params: GetApiAdministrativeV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyDetailResponse>> {
    return getApiAdministrativeV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a company by its ID from the database asynchronously.
   *
   * Retrieves a company by its ID from the database asynchronously.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiAdministrativeV1Id$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiAdministrativeV1Id$Json(params: GetApiAdministrativeV1Id$Json$Params, context?: HttpContext): Observable<CompanyDetailResponse> {
    return this.getApiAdministrativeV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompanyDetailResponse>): CompanyDetailResponse => r.body)
    );
  }

  /** Path part for operation `putApiAdministrativeV1Id()` */
  static readonly PutApiAdministrativeV1IdPath = '/private/v1/companies/{id}';

  /**
   * Updates an existing company in the database asynchronously.
   *
   * Updates an existing company in the database asynchronously.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putApiAdministrativeV1Id$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiAdministrativeV1Id$Plain$Response(params: PutApiAdministrativeV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyDetailResponse>> {
    return putApiAdministrativeV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing company in the database asynchronously.
   *
   * Updates an existing company in the database asynchronously.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putApiAdministrativeV1Id$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiAdministrativeV1Id$Plain(params: PutApiAdministrativeV1Id$Plain$Params, context?: HttpContext): Observable<CompanyDetailResponse> {
    return this.putApiAdministrativeV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompanyDetailResponse>): CompanyDetailResponse => r.body)
    );
  }

  /**
   * Updates an existing company in the database asynchronously.
   *
   * Updates an existing company in the database asynchronously.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putApiAdministrativeV1Id$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiAdministrativeV1Id$Json$Response(params: PutApiAdministrativeV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyDetailResponse>> {
    return putApiAdministrativeV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing company in the database asynchronously.
   *
   * Updates an existing company in the database asynchronously.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putApiAdministrativeV1Id$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiAdministrativeV1Id$Json(params: PutApiAdministrativeV1Id$Json$Params, context?: HttpContext): Observable<CompanyDetailResponse> {
    return this.putApiAdministrativeV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompanyDetailResponse>): CompanyDetailResponse => r.body)
    );
  }

  /** Path part for operation `deleteApiAdministrativeV1Id()` */
  static readonly DeleteApiAdministrativeV1IdPath = '/private/v1/companies/{id}';

  /**
   * Deletes an existing company in the database asynchronously.
   *
   * Deletes an existing company in the database asynchronously.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteApiAdministrativeV1Id()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiAdministrativeV1Id$Response(params: DeleteApiAdministrativeV1Id$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteApiAdministrativeV1Id(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes an existing company in the database asynchronously.
   *
   * Deletes an existing company in the database asynchronously.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteApiAdministrativeV1Id$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiAdministrativeV1Id(params: DeleteApiAdministrativeV1Id$Params, context?: HttpContext): Observable<void> {
    return this.deleteApiAdministrativeV1Id$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `postApiAdministrativeV1Create()` */
  static readonly PostApiAdministrativeV1CreatePath = '/private/v1/companies/create';

  /**
   * Creates a new company in the database asynchronously.
   *
   * Creates a new company in the database asynchronously.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAdministrativeV1Create$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAdministrativeV1Create$Plain$Response(params?: PostApiAdministrativeV1Create$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyDetailResponse>> {
    return postApiAdministrativeV1Create$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new company in the database asynchronously.
   *
   * Creates a new company in the database asynchronously.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAdministrativeV1Create$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAdministrativeV1Create$Plain(params?: PostApiAdministrativeV1Create$Plain$Params, context?: HttpContext): Observable<CompanyDetailResponse> {
    return this.postApiAdministrativeV1Create$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompanyDetailResponse>): CompanyDetailResponse => r.body)
    );
  }

  /**
   * Creates a new company in the database asynchronously.
   *
   * Creates a new company in the database asynchronously.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAdministrativeV1Create$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAdministrativeV1Create$Json$Response(params?: PostApiAdministrativeV1Create$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyDetailResponse>> {
    return postApiAdministrativeV1Create$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new company in the database asynchronously.
   *
   * Creates a new company in the database asynchronously.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAdministrativeV1Create$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAdministrativeV1Create$Json(params?: PostApiAdministrativeV1Create$Json$Params, context?: HttpContext): Observable<CompanyDetailResponse> {
    return this.postApiAdministrativeV1Create$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompanyDetailResponse>): CompanyDetailResponse => r.body)
    );
  }

  /** Path part for operation `getApiAdministrativeV1IdStructures()` */
  static readonly GetApiAdministrativeV1IdStructuresPath = '/private/v1/companies/{id}/structures';

  /**
   * /private/api/Administrative/v1/{id}/structures - GET.
   *
   * /private/api/Administrative/v1/{id}/structures - GET
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiAdministrativeV1IdStructures$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiAdministrativeV1IdStructures$Plain$Response(params: GetApiAdministrativeV1IdStructures$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAdministrativeStructuresResponse>> {
    return getApiAdministrativeV1IdStructures$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * /private/api/Administrative/v1/{id}/structures - GET.
   *
   * /private/api/Administrative/v1/{id}/structures - GET
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiAdministrativeV1IdStructures$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiAdministrativeV1IdStructures$Plain(params: GetApiAdministrativeV1IdStructures$Plain$Params, context?: HttpContext): Observable<GetAdministrativeStructuresResponse> {
    return this.getApiAdministrativeV1IdStructures$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetAdministrativeStructuresResponse>): GetAdministrativeStructuresResponse => r.body)
    );
  }

  /**
   * /private/api/Administrative/v1/{id}/structures - GET.
   *
   * /private/api/Administrative/v1/{id}/structures - GET
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiAdministrativeV1IdStructures$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiAdministrativeV1IdStructures$Json$Response(params: GetApiAdministrativeV1IdStructures$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAdministrativeStructuresResponse>> {
    return getApiAdministrativeV1IdStructures$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * /private/api/Administrative/v1/{id}/structures - GET.
   *
   * /private/api/Administrative/v1/{id}/structures - GET
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiAdministrativeV1IdStructures$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiAdministrativeV1IdStructures$Json(params: GetApiAdministrativeV1IdStructures$Json$Params, context?: HttpContext): Observable<GetAdministrativeStructuresResponse> {
    return this.getApiAdministrativeV1IdStructures$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetAdministrativeStructuresResponse>): GetAdministrativeStructuresResponse => r.body)
    );
  }

  /** Path part for operation `getApiAdministrativeV1IdCustomers()` */
  static readonly GetApiAdministrativeV1IdCustomersPath = '/private/v1/companies/{id}/customers';

  /**
   * Fetches all customers associated with a company by its ID from the database asynchronously.
   *
   * Fetches all customers associated with a company by its ID from the database asynchronously.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiAdministrativeV1IdCustomers$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiAdministrativeV1IdCustomers$Plain$Response(params: GetApiAdministrativeV1IdCustomers$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCompanyCustomersResponse>> {
    return getApiAdministrativeV1IdCustomers$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Fetches all customers associated with a company by its ID from the database asynchronously.
   *
   * Fetches all customers associated with a company by its ID from the database asynchronously.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiAdministrativeV1IdCustomers$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiAdministrativeV1IdCustomers$Plain(params: GetApiAdministrativeV1IdCustomers$Plain$Params, context?: HttpContext): Observable<GetCompanyCustomersResponse> {
    return this.getApiAdministrativeV1IdCustomers$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetCompanyCustomersResponse>): GetCompanyCustomersResponse => r.body)
    );
  }

  /**
   * Fetches all customers associated with a company by its ID from the database asynchronously.
   *
   * Fetches all customers associated with a company by its ID from the database asynchronously.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiAdministrativeV1IdCustomers$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiAdministrativeV1IdCustomers$Json$Response(params: GetApiAdministrativeV1IdCustomers$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCompanyCustomersResponse>> {
    return getApiAdministrativeV1IdCustomers$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Fetches all customers associated with a company by its ID from the database asynchronously.
   *
   * Fetches all customers associated with a company by its ID from the database asynchronously.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiAdministrativeV1IdCustomers$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiAdministrativeV1IdCustomers$Json(params: GetApiAdministrativeV1IdCustomers$Json$Params, context?: HttpContext): Observable<GetCompanyCustomersResponse> {
    return this.getApiAdministrativeV1IdCustomers$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetCompanyCustomersResponse>): GetCompanyCustomersResponse => r.body)
    );
  }

  /** Path part for operation `getApiAdministrativeV1IdAgents()` */
  static readonly GetApiAdministrativeV1IdAgentsPath = '/private/v1/companies/{id}/agents';

  /**
   * Fetches all agents associated with a company by its ID from the database asynchronously.
   *
   * Fetches all agents associated with a company by its ID from the database asynchronously.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiAdministrativeV1IdAgents$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiAdministrativeV1IdAgents$Plain$Response(params: GetApiAdministrativeV1IdAgents$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCompanyAgentsResponse>> {
    return getApiAdministrativeV1IdAgents$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Fetches all agents associated with a company by its ID from the database asynchronously.
   *
   * Fetches all agents associated with a company by its ID from the database asynchronously.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiAdministrativeV1IdAgents$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiAdministrativeV1IdAgents$Plain(params: GetApiAdministrativeV1IdAgents$Plain$Params, context?: HttpContext): Observable<GetCompanyAgentsResponse> {
    return this.getApiAdministrativeV1IdAgents$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetCompanyAgentsResponse>): GetCompanyAgentsResponse => r.body)
    );
  }

  /**
   * Fetches all agents associated with a company by its ID from the database asynchronously.
   *
   * Fetches all agents associated with a company by its ID from the database asynchronously.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiAdministrativeV1IdAgents$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiAdministrativeV1IdAgents$Json$Response(params: GetApiAdministrativeV1IdAgents$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCompanyAgentsResponse>> {
    return getApiAdministrativeV1IdAgents$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Fetches all agents associated with a company by its ID from the database asynchronously.
   *
   * Fetches all agents associated with a company by its ID from the database asynchronously.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiAdministrativeV1IdAgents$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiAdministrativeV1IdAgents$Json(params: GetApiAdministrativeV1IdAgents$Json$Params, context?: HttpContext): Observable<GetCompanyAgentsResponse> {
    return this.getApiAdministrativeV1IdAgents$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetCompanyAgentsResponse>): GetCompanyAgentsResponse => r.body)
    );
  }

  /** Path part for operation `postApiAdministrativeV1Export()` */
  static readonly PostApiAdministrativeV1ExportPath = '/private/v1/companies/export';

  /**
   * Export companies to CSV file report.
   *
   * Export companies to CSV file report.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAdministrativeV1Export$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAdministrativeV1Export$Plain$Response(params?: PostApiAdministrativeV1Export$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return postApiAdministrativeV1Export$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Export companies to CSV file report.
   *
   * Export companies to CSV file report.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAdministrativeV1Export$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAdministrativeV1Export$Plain(params?: PostApiAdministrativeV1Export$Plain$Params, context?: HttpContext): Observable<Blob> {
    return this.postApiAdministrativeV1Export$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /**
   * Export companies to CSV file report.
   *
   * Export companies to CSV file report.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAdministrativeV1Export$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAdministrativeV1Export$Json$Response(params?: PostApiAdministrativeV1Export$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return postApiAdministrativeV1Export$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Export companies to CSV file report.
   *
   * Export companies to CSV file report.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAdministrativeV1Export$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAdministrativeV1Export$Json(params?: PostApiAdministrativeV1Export$Json$Params, context?: HttpContext): Observable<Blob> {
    return this.postApiAdministrativeV1Export$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `postApiAdministrativeV1IdLock()` */
  static readonly PostApiAdministrativeV1IdLockPath = '/private/v1/companies/{id}/lock';

  /**
   * Lock company by internal ID.
   *
   * Lock company by internal ID
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAdministrativeV1IdLock()` instead.
   *
   * This method doesn't expect any request body.
   */
  postApiAdministrativeV1IdLock$Response(params: PostApiAdministrativeV1IdLock$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postApiAdministrativeV1IdLock(this.http, this.rootUrl, params, context);
  }

  /**
   * Lock company by internal ID.
   *
   * Lock company by internal ID
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAdministrativeV1IdLock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postApiAdministrativeV1IdLock(params: PostApiAdministrativeV1IdLock$Params, context?: HttpContext): Observable<void> {
    return this.postApiAdministrativeV1IdLock$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `postApiAdministrativeV1IdUnlock()` */
  static readonly PostApiAdministrativeV1IdUnlockPath = '/private/v1/companies/{id}/unlock';

  /**
   * Unlock company by internal ID.
   *
   * Unlock company by internal ID
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAdministrativeV1IdUnlock()` instead.
   *
   * This method doesn't expect any request body.
   */
  postApiAdministrativeV1IdUnlock$Response(params: PostApiAdministrativeV1IdUnlock$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postApiAdministrativeV1IdUnlock(this.http, this.rootUrl, params, context);
  }

  /**
   * Unlock company by internal ID.
   *
   * Unlock company by internal ID
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAdministrativeV1IdUnlock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postApiAdministrativeV1IdUnlock(params: PostApiAdministrativeV1IdUnlock$Params, context?: HttpContext): Observable<void> {
    return this.postApiAdministrativeV1IdUnlock$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `postApiAdministrativeV1IdHistory()` */
  static readonly PostApiAdministrativeV1IdHistoryPath = '/private/v1/companies/{id}/history';

  /**
   * Retrieves the list of all modification done to the administrative with the provided ID.
   *
   * Retrieves the list of all modification done to the administrative with the provided ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAdministrativeV1IdHistory$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAdministrativeV1IdHistory$Plain$Response(params: PostApiAdministrativeV1IdHistory$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AdministrativeFieldsHistoryResponse>> {
    return postApiAdministrativeV1IdHistory$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves the list of all modification done to the administrative with the provided ID.
   *
   * Retrieves the list of all modification done to the administrative with the provided ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAdministrativeV1IdHistory$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAdministrativeV1IdHistory$Plain(params: PostApiAdministrativeV1IdHistory$Plain$Params, context?: HttpContext): Observable<AdministrativeFieldsHistoryResponse> {
    return this.postApiAdministrativeV1IdHistory$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdministrativeFieldsHistoryResponse>): AdministrativeFieldsHistoryResponse => r.body)
    );
  }

  /**
   * Retrieves the list of all modification done to the administrative with the provided ID.
   *
   * Retrieves the list of all modification done to the administrative with the provided ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAdministrativeV1IdHistory$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAdministrativeV1IdHistory$Json$Response(params: PostApiAdministrativeV1IdHistory$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AdministrativeFieldsHistoryResponse>> {
    return postApiAdministrativeV1IdHistory$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves the list of all modification done to the administrative with the provided ID.
   *
   * Retrieves the list of all modification done to the administrative with the provided ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAdministrativeV1IdHistory$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAdministrativeV1IdHistory$Json(params: PostApiAdministrativeV1IdHistory$Json$Params, context?: HttpContext): Observable<AdministrativeFieldsHistoryResponse> {
    return this.postApiAdministrativeV1IdHistory$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdministrativeFieldsHistoryResponse>): AdministrativeFieldsHistoryResponse => r.body)
    );
  }

  /** Path part for operation `postApiAdministrativeV1IdHistoryExport()` */
  static readonly PostApiAdministrativeV1IdHistoryExportPath = '/private/v1/companies/{id}/history-export';

  /**
   * Export the list of all modification done to the administrative with the provided ID.
   *
   * Export the list of all modification done to the administrative with the provided ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAdministrativeV1IdHistoryExport$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAdministrativeV1IdHistoryExport$Plain$Response(params: PostApiAdministrativeV1IdHistoryExport$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return postApiAdministrativeV1IdHistoryExport$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the list of all modification done to the administrative with the provided ID.
   *
   * Export the list of all modification done to the administrative with the provided ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAdministrativeV1IdHistoryExport$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAdministrativeV1IdHistoryExport$Plain(params: PostApiAdministrativeV1IdHistoryExport$Plain$Params, context?: HttpContext): Observable<Blob> {
    return this.postApiAdministrativeV1IdHistoryExport$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /**
   * Export the list of all modification done to the administrative with the provided ID.
   *
   * Export the list of all modification done to the administrative with the provided ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAdministrativeV1IdHistoryExport$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAdministrativeV1IdHistoryExport$Json$Response(params: PostApiAdministrativeV1IdHistoryExport$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return postApiAdministrativeV1IdHistoryExport$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the list of all modification done to the administrative with the provided ID.
   *
   * Export the list of all modification done to the administrative with the provided ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAdministrativeV1IdHistoryExport$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAdministrativeV1IdHistoryExport$Json(params: PostApiAdministrativeV1IdHistoryExport$Json$Params, context?: HttpContext): Observable<Blob> {
    return this.postApiAdministrativeV1IdHistoryExport$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `postAdministrativeV1CompaniesWithoutBreakVisibility()` */
  static readonly PostAdministrativeV1CompaniesWithoutBreakVisibilityPath = '/private/v1/companies/without-break-visibility';

  /**
   * Retrive the list all the existing Companies from the database asynchronously without break visibility.
   *
   * Retrive the list all the existing Companies from the database asynchronously without break visibility
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postAdministrativeV1CompaniesWithoutBreakVisibility$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postAdministrativeV1CompaniesWithoutBreakVisibility$Plain$Response(params?: PostAdministrativeV1CompaniesWithoutBreakVisibility$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAdministrativesResponse>> {
    return postAdministrativeV1CompaniesWithoutBreakVisibility$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrive the list all the existing Companies from the database asynchronously without break visibility.
   *
   * Retrive the list all the existing Companies from the database asynchronously without break visibility
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postAdministrativeV1CompaniesWithoutBreakVisibility$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postAdministrativeV1CompaniesWithoutBreakVisibility$Plain(params?: PostAdministrativeV1CompaniesWithoutBreakVisibility$Plain$Params, context?: HttpContext): Observable<GetAdministrativesResponse> {
    return this.postAdministrativeV1CompaniesWithoutBreakVisibility$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetAdministrativesResponse>): GetAdministrativesResponse => r.body)
    );
  }

  /**
   * Retrive the list all the existing Companies from the database asynchronously without break visibility.
   *
   * Retrive the list all the existing Companies from the database asynchronously without break visibility
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postAdministrativeV1CompaniesWithoutBreakVisibility$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postAdministrativeV1CompaniesWithoutBreakVisibility$Json$Response(params?: PostAdministrativeV1CompaniesWithoutBreakVisibility$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAdministrativesResponse>> {
    return postAdministrativeV1CompaniesWithoutBreakVisibility$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrive the list all the existing Companies from the database asynchronously without break visibility.
   *
   * Retrive the list all the existing Companies from the database asynchronously without break visibility
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postAdministrativeV1CompaniesWithoutBreakVisibility$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postAdministrativeV1CompaniesWithoutBreakVisibility$Json(params?: PostAdministrativeV1CompaniesWithoutBreakVisibility$Json$Params, context?: HttpContext): Observable<GetAdministrativesResponse> {
    return this.postAdministrativeV1CompaniesWithoutBreakVisibility$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetAdministrativesResponse>): GetAdministrativesResponse => r.body)
    );
  }

  /** Path part for operation `postAdministrativeV1CompaniesUserDetail()` */
  static readonly PostAdministrativeV1CompaniesUserDetailPath = '/private/v1/companies/user-detail';

  /**
   * Retrive the list all the existing Companies from the database asynchronously.
   *
   * Retrive the list all the existing Companies from the database asynchronously
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postAdministrativeV1CompaniesUserDetail$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postAdministrativeV1CompaniesUserDetail$Plain$Response(params?: PostAdministrativeV1CompaniesUserDetail$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAdministrativesResponse>> {
    return postAdministrativeV1CompaniesUserDetail$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrive the list all the existing Companies from the database asynchronously.
   *
   * Retrive the list all the existing Companies from the database asynchronously
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postAdministrativeV1CompaniesUserDetail$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postAdministrativeV1CompaniesUserDetail$Plain(params?: PostAdministrativeV1CompaniesUserDetail$Plain$Params, context?: HttpContext): Observable<GetAdministrativesResponse> {
    return this.postAdministrativeV1CompaniesUserDetail$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetAdministrativesResponse>): GetAdministrativesResponse => r.body)
    );
  }

  /**
   * Retrive the list all the existing Companies from the database asynchronously.
   *
   * Retrive the list all the existing Companies from the database asynchronously
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postAdministrativeV1CompaniesUserDetail$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postAdministrativeV1CompaniesUserDetail$Json$Response(params?: PostAdministrativeV1CompaniesUserDetail$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAdministrativesResponse>> {
    return postAdministrativeV1CompaniesUserDetail$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrive the list all the existing Companies from the database asynchronously.
   *
   * Retrive the list all the existing Companies from the database asynchronously
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postAdministrativeV1CompaniesUserDetail$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postAdministrativeV1CompaniesUserDetail$Json(params?: PostAdministrativeV1CompaniesUserDetail$Json$Params, context?: HttpContext): Observable<GetAdministrativesResponse> {
    return this.postAdministrativeV1CompaniesUserDetail$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetAdministrativesResponse>): GetAdministrativesResponse => r.body)
    );
  }

}
